import React, { useEffect } from "react";
import Dashboardmenus from "./Dashboardmenus";
import { authcallApi } from "../../common/API/Api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBaseUrl } from "../../common/BaseUrl";
const Closeaccount = () => {
  const location = useLocation();
  const state = location.state;
    const navigate = useNavigate();
    console.log(state, "statestate")
  let base_url = getBaseUrl();
  const restoreaccount = async () => {
    try {
      let postdata = {id: state?.from?.id};
 
      let res = await authcallApi(postdata, `api/restoreaccount`, "POST");
      if (res?.data?.success) {
         navigate(`${base_url}restoreaccount`);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (!state) {
      window.location.href = `${base_url}login`;
      localStorage.setItem("token", "");
    }
  }, []);
  return (
    <React.Fragment>
      {/* <Dashboardmenus /> */}
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-md-8 col-sm-10 col-12">
                <div className="text-center mb-3">
                  <h4 className="card_title">Account closed</h4>
                  <div className="alertBox">
                    <div className="alert alert-danger-pink">
                      <div className="">
                        <div className="blockIcon"><i class="fa-solid fa-ban"></i></div>
                        <p className="text-white mb-2">Your comment: I would like to take a break frome trading and maybe resume later</p>
                        <p className="text-white mb-2">You have previously closed your trading account. If you wish to resume it, click on the "Restore account" button below.</p>
                        <Link to="mailto:support@equlix.com">
                          support@equlix.com
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="close_account">
                    <button
                      type="button"
                      className="btn bg_btn"
                      onClick={() => restoreaccount()}
                    >
                      Restore account
                    </button>
                    <Link to={base_url} type="button" className="btn bg_btn">
                      Go to Home
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Closeaccount;
